import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1417c225"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "mt-10" }, [
  /*#__PURE__*/_createTextVNode(" NESTINGアプリは、ベースとなるテンプレートをもとに、お好みの内観・外観のスタイルへ変更し、金額も試算できるアプリケーションです。 "),
  /*#__PURE__*/_createElementVNode("a", {
    class: "text-decoration-underline text-caption",
    href: "https://note.com/nesting_me/n/n7bb4a44fca88"
  }, " 詳しい使い方を見る ")
], -1))
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "d-flex justify-center align-center" }, [
  /*#__PURE__*/_createElementVNode("iframe", {
    class: "d-block",
    style: {"width":"560px","height":"315px","max-width":"calc(100vw - 80px)","max-height":"calc(100vh - 80px)"},
    src: "https://www.youtube.com/embed/PnwWKpcdAZo?autoplay=1",
    frameborder: "0",
    allowfullscreen: ""
  })
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_Header = _resolveComponent("Header")!
  const _component_v_img = _resolveComponent("v-img")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_container = _resolveComponent("v-container")!
  const _component_v_main = _resolveComponent("v-main")!
  const _component_v_dialog = _resolveComponent("v-dialog")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_Header, null, {
      default: _withCtx(() => [
        _createVNode(_component_v_spacer),
        _createVNode(_component_v_btn, { href: "https://note.com/nesting_me/n/n7bb4a44fca88" }, {
          default: _withCtx(() => [
            _createVNode(_component_v_icon, { left: "" }, {
              default: _withCtx(() => [
                _createTextVNode(" mdi-help ")
              ]),
              _: 1
            }),
            _createTextVNode(" 使い方 ")
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_v_main, null, {
      default: _withCtx(() => [
        _createVNode(_component_v_container, { class: "px-10" }, {
          default: _withCtx(() => [
            _hoisted_1,
            _createVNode(_component_v_card, {
              class: "flex d-flex flex-column py-2",
              link: "",
              to: { name: 'Model', params: {} }
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_img, {
                  cover: true,
                  src: _ctx.image,
                  height: "320px"
                }, null, 8, ["src"]),
                _createVNode(_component_v_card_title, { class: "pb-0 mb-1" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_icon, { left: "" }, {
                      default: _withCtx(() => [
                        _createTextVNode(" mdi-pencil ")
                      ]),
                      _: 1
                    }),
                    _createTextVNode(" エディター画面へ ")
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_v_dialog, {
      modelValue: _ctx.state.video,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.state.video) = $event))
    }, {
      default: _withCtx(() => [
        _hoisted_2
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}